import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { reduxForm } from 'redux-form';
import { useIntl } from 'react-intl';
import { Box, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import forgotPasswordFormValidation from '@htmniseko/htm-validators/rules/forgotPasswordFormValidation';
import FormattedTranslation from 'components/Common/FormattedTranslationMui';
import SecondaryButton from 'components/Buttons/SecondaryButton';
import EmailField from 'components/Form/FormField/EmailField';

export const LinkLoginForm = ({ handleSubmit, loading }) => {
  const [waiting, setWaiting] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const intl = useIntl();

  useEffect(() => {
    if (loading) {
      // The request may be fast, timeout 2 seconds to give a better processing feedback to the user
      setWaiting(true);
      setTimeout(() => setWaiting(false), 2000);
    }
  }, [loading]);

  const inProgress = loading || waiting;

  return (
    <form onSubmit={handleSubmit}>
      <Box mb={1}>
        <EmailField
          id="email"
          hideLabel={isMobile}
          fieldSizeSM={12}
          label={intl.formatMessage({ id: 'page.login.passwordLogin.email' })}
        />
      </Box>
      <SecondaryButton disabled={inProgress} fullWidth type="submit" variant="contained">
        <Box fontWeight="fontWeightBold">
          <FormattedTranslation id={inProgress ? 'page.login.linkLogin.sending' : 'page.login.linkLogin.send'} />
        </Box>
      </SecondaryButton>
    </form>
  );
};

LinkLoginForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};

LinkLoginForm.defaultProps = {
  loading: false,
};

// Uses the same validation as forgot password. Since it's only validation for email address.
export default reduxForm({ form: 'linkLogin', validate: forgotPasswordFormValidation })(LinkLoginForm);
